import argentina from "./argentina";
import base from "./base";
import chile from "./chile";
import chile_corporate from "./chile_corporate";
import { CONFIG_NAME } from "./enums";
import otros from "./otros";
import peru from "./peru";

const CONFIGS = [base, argentina, chile_corporate, chile, otros, peru];

export const findConfigByName = (name: CONFIG_NAME) => {
  const config = CONFIGS.find((config) => config.name === name);

  if (!config) throw new Error(`Config with name ${name} not found`);

  return config;
};
